package pl.decks.chartjs.style

import pl.decks.chartjs.model.JSEnum

@Suppress("unused")
enum class BorderCapStyle(override val jsValue: String) : JSEnum {
    Butt("butt"),
    Round("round"),
    Square("square"),
}
